import React, { useCallback } from 'react';
import { StyledLeadContainer,  StyledFlexEnd, StyledConfigurationContainer, StyledIndexContainerDiv } from '../../../Components/Styled';
import TextFiledWithLabel from '../../../Components/TextFieldWithLabel';
import { Box, Button, Autocomplete,Typography, Stack, Tooltip } from '@mui/material';
import { GridRowModes,GridActionsCellItem } from '@mui/x-data-grid';
import { useState } from 'react';
import DataGridTable from '../../../Components/DataGrid';
import CheckIcon from '@mui/icons-material/Check';
import CancelIcon from '@mui/icons-material/Close';
import CreateEditUser from './CreateEditUser';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { requestgetAllUser, requestGetUserList } from '../../../Store/User/action';
import BiztantuLoader from '../../../Components/Loader';
import LeadDialog from '../../../Components/LeadDialog';
import { requestGetAllRoles } from '../../../Store/Function/action';
import { createRequestData, dateFormatting, getRequestData, getRequestDataWithoutToken, isValidEmail, searchRequestData } from '../../../Utility/apiHelper';
import { useSnackbar } from 'notistack';
import { ACTIVE_STATUS, dateTimeISTFormatter, emailWidth, fullNameWidth, handleValidateCodevalue, idWidth, nameWidth, phoneWidth, statusWidth, whocolumnWidth } from '../../../Utility/constant';
import axios from 'axios';
import SelectBoxWithLabel from '../../../Components/SelectBoxWithLable';
import moment from 'moment';
import { WhoColumns } from '../../../Components/WhoColumns';
import AutoCompleteComponent from '../../../Components/AutoCompleteComponenet';
import EditIcon from '@mui/icons-material/Edit';
import NumericTextField from '../../../Components/NumericTextfield';
import CommonEmail from '../../../Components/CommonEmail';
import BiztantuSearch from '../../../Components/BiztantuSearch';
import { handleCreateEditConfiguration } from '../../../Store/Global/action';
import tableBodyicon from '../../../Assets/images/tablebody_edit.png';
import tableEditicon from '../../../Assets/images/tableheader_edit.png';
import createicon from '../../../Assets/images/add.png';
import { sessionExpiredDialog } from '../../../Utility/sessionExpired';
import SendNotification from '../../../Components/SendNotification';

const User = ({isUserScreen = true}) => {
  
    const [isLoading, setIsLoading] = useState(false);
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
    const today = new Date();
    const daysAgo = new Date();
    daysAgo.setDate(today.getDate() - 180);
    const currentUser = useSelector(state => state?.owner?.currentuser);

    const [formValues, setFormValues] = useState({
    updatedFrom: dateFormatting(daysAgo),
    updatedTo: dateFormatting(today),
    });
    const [datagriddata, setdatagriddata] = useState([]);
    const [rowModesModel, setRowModesModel] = React.useState({});
    const [iscreateuser, setCreateuser] = useState(false);
    const [isEdituser, setEdituser] = useState(false);
    const [currentuserid, setcurrentuserid] = useState("");
    const isLoadingProgress = useSelector(state => state?.global.isLoading);
    const dispatch = useDispatch();
    const [selectionModel, setSelectionModel] = React.useState([]);
    const [assignRoleDetails, setassignroledetails] = useState({
      isOpen: false
    });
    const [companyList, setcomapnyList] = useState([]);
        const currentCompanyId = currentUser?.client?.id
    const [isViewMode , setIsViewMode] = useState(false)
    useEffect(() => {
        dispatch(requestGetAllRoles());
    },[])
    const {enqueueSnackbar} = useSnackbar();
  
    const[selectedRoles, setSelectedRoles] = useState([]);
    const allrolesData = useSelector(state => state?.permission?.allRoleTypes);
    const userStatusData = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == 'USER_STATUS')?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);
    const userData = useSelector(state => state?.owner?.userList);


  useEffect(() => {
     getAllUserListData();

     return ()=>{
      setdatagriddata([])
     }
  },[])

  useEffect(()=>{
    const mappedUserData = (userData || [])?.map((item)=>{
      return{
      ...item,
  }})
    setdatagriddata(mappedUserData)
    
  },[userData])

  const getAllUserListData = useCallback(() => {
    const queryparams = {
        params: isUserScreen ? {
            ...formValues,
        } : {clientId : currentCompanyId}
    };
    dispatch(requestGetUserList(queryparams));
    getAllComapnyDetails();
}, [isUserScreen, formValues, dispatch]);
  const getAllComapnyDetails = async() => {
      const url = `${process.env.REACT_APP_BASE_URL}companies`;
      const responseData = await getRequestData(url);
      if(responseData?.status == 200) {
            const newMappedData = responseData?.data?.map(item => {
              return {
                ...item,
                id: item?.id
              }
            })
            
            setcomapnyList(newMappedData);
        }
  }


    const handleOnChange = (event) => {
        setFormValues({
          ...formValues,
          [event.target.name]: event.target.value
      })
    }

    const handleSelectCompany = (event, company) => {
      if (company) {
       if (!iscreateuser && !isEdituser){
          setFormValues({
            ...formValues,
            selectedCompany : company,
           });
        }}
  };

    const handleSaveClick = (id) => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
    }

    const handleEditClick = (id) => {
          setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
    }

    const handleEditApplication = (id,value) => {
        setEdituser(true);
        setCreateuser(false);
        setcurrentuserid(id);
        setIsViewMode(value);
        dispatch(handleCreateEditConfiguration(true));
    }

    const handleCancelClick = (id) => {
    setRowModesModel({
    ...rowModesModel,
    [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });
  }

    const columns = [
      
 ...(isUserScreen
    ? [
        {
          field: 'actions',
          type: 'actions',
          headerName: <Tooltip title={handleValidateCodevalue(internationalise,'COMMON_ACTION')} ><img src={tableEditicon} style={{paddingTop: "18px"}} /></Tooltip>,
          width: 100,
          cellClassName: 'actions',
          getActions: ({ id }) => {
            const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
    
            if (isInEditMode) {
              return [
                <GridActionsCellItem
                  icon={<CheckIcon />}
                  label={handleValidateCodevalue(internationalise,'COMMON_SAVE')}
                  className="textPrimary"
                  onClick={()=>handleSaveClick(id)}
                />,
                <GridActionsCellItem
                  icon={<CancelIcon />}
                  label={handleValidateCodevalue(internationalise,'COMMON_CANCEL')}
                  className="textPrimary"
                  onClick={()=>handleCancelClick(id)}
                  color="inherit"
                />,
              ];
            }
    
            return [
              <GridActionsCellItem
                icon={<img src={tableBodyicon} />}
                label={handleValidateCodevalue(internationalise,'COMMON_EDIT')}
                className="textPrimary"
                onClick={()=>handleEditClick(id)}
                color="inherit"
              />,
              // <GridActionsCellItem
              //   icon={<BorderColorIcon />}
              //   label={handleValidateCodevalue(internationalise,'CONFIGURATION_USER_EDIT_RECORD')}
              //   className="textPrimary"
              //   onClick={() => handleEditApplication(id,false)}
              //   color="inherit"
              // />,
            ];
          },
        },
      ] : []),
      { 
        field: 'id', 
        headerName: handleValidateCodevalue(internationalise,'CONF_USER_SEARCH_ID'),
        flex: 1,
        minWidth : idWidth,
        editable : false,
        renderCell: (params) => (
         isUserScreen ? <a 
            href="#"
            onClick={(e) => {
              e.preventDefault();
              handleEditApplication(params.row.id,true);
            }}
            style={{ color: '#1242C8', textDecoration: 'underline', cursor: 'pointer' }}
          >
            {params.row.id}
          </a>
          :     
      <span>
        {params.row.id}
      </span>
        )
      },
        { 
          field: 'firstName', 
          headerName: handleValidateCodevalue(internationalise,'CONF_USER_SEARCH_FIRSTNAME'),
          flex: 1,
          minWidth : nameWidth,
          editable: true ,
        },
        {
            field: 'lastName',
            headerName:handleValidateCodevalue(internationalise,'CONF_USER_SEARCH_LASTNAME'),
            flex: 1,
            minWidth : nameWidth,
            editable: true,
        },
          {
            field: 'status',
            headerName: handleValidateCodevalue(internationalise,'CONF_USER_SEARCH_STATUS'),
            flex: 1,
            minWidth : statusWidth,
            editable: false,
              valueGetter:({value})=>{
                if(!value){
                  return ""
                }
                return handleValidateCodevalue(internationalise,value)
              }
        },
        {
          field: 'lastLoginAt',
            headerName: handleValidateCodevalue(internationalise,'CONF_USER_LAST_LOGGED_IN_AT'),
          flex: 1,
          minWidth : emailWidth,
          valueFormatter: (params) => {
          if (!params?.value) return "";
            return dateTimeISTFormatter(params?.value);
          }
        },
        {
          field: 'userEmail',
          headerName: handleValidateCodevalue(internationalise,'COMMON_EMAIL_ID'),
          flex: 1,
          minWidth : emailWidth,
          editable: true,
        },
        {
          field: 'mobile',
          headerName: handleValidateCodevalue(internationalise,'COMMON_PHONE_NUMBER'),
          flex: 1,
          minWidth : phoneWidth,
          editable: false,
        },
        { 
          field: 'companyName', 
          headerName: handleValidateCodevalue(internationalise,'CONF_USER_SEARCH_CLIENT'),
          flex: 1,
          minWidth : nameWidth,
          editable: false ,
        },     
         {
          field: 'createdAt',
          headerName: handleValidateCodevalue(internationalise,'COMMON_CREATED_AT'),
          flex: 1,
          minWidth : whocolumnWidth,
          editable: false,
          valueGetter: ({ value }) => value && moment(value).format('MM/DD/YYYY'),
         },
         {
          field: 'updatedAt',
          headerName: handleValidateCodevalue(internationalise,'COMMON_UPDATED_AT'),
          flex: 1,
          minWidth : whocolumnWidth,
          editable: false,
          valueGetter: ({ value }) => value && moment(value).format('MM/DD/YYYY'),
         },
        // {
        //   field: 'created',
        //   headerName: 'Created At',
        //   type: 'date',
        //   flex: 1,
        //   editable: false,
        //   valueGetter: ({ value }) => value && moment(value).format('MM/DD/YYYY'),
        // },
        // {
        //   field: 'updated',
        //   type: 'date',
        //   headerName: 'Updated At',
        //   flex: 1,
        //   editable: false,
        //   valueGetter: ({ value }) => value && moment(value).format('MM/DD/YYYY'),
        // },
      ];

    const handleSearch = async () => {
                  setIsLoading(true);
                  // const hasValidParams = Object.values(formValues).some(
                  // value => value !== undefined && value !== null && String(value).trim() !== ''
                  // );
                  // if (!hasValidParams) {
                  // setIsLoading(false)
                  // setdatagriddata([])
                  // enqueueSnackbar(handleValidateCodevalue(internationalise,'ENTER_AT_LEAST_ONE_SEARCH_FIELD'), {variant: 'warning'});
                  // return;
                  // }
                  const {selectedCompany,...restValues} = formValues
                  const queryparams = {
                    params: {
                      ...restValues,
                      clientId:selectedCompany?.id
                    },
                  };
                  dispatch(requestGetUserList(queryparams))
                  setdatagriddata([])
                  setIsLoading(false)
}


    const handleResetSearch = () => {
      setFormValues({
        selectedCompany : null,
        id : "",
        firstName:"",
        lastName:"",
        phone:"",
        department:"",
        email:"",
        function:"",
        managerId:"",
        createdFrom : "",
        createdTo:"",
        updatedFrom:"",
        updatedTo:"",
        selectedCompany : null,
      })
    }

    const handleCreateuser = () => {
        setCreateuser(true);
        dispatch(handleCreateEditConfiguration(true));
    }
    
    const handlebackbutton = () => {
        handleResetSearch();
        setEdituser(false);
        setCreateuser(false);
        dispatch(handleCreateEditConfiguration(false));
        getAllUserListData()
    }

    const handleAssignRoles = () => {
      setassignroledetails({
        ...assignRoleDetails,
        isOpen: true
      })
    }

    const handleCloseAssignModal = () => {
      setassignroledetails({
        ...assignRoleDetails,
        isOpen: false
      });
      setSelectedRoles([]);
    }

    const handleSaveAssignRoles = async() => {
      if(selectedRoles.length > 0) {
        const roleIds =  selectedRoles?.map(item => item?.id);
        const reqBody = {
          "roleIds": roleIds,
          "userId": selectionModel[0]
        }

        const url = `${process.env.REACT_APP_BASE_URL}user-role`;

        const responseData = await createRequestData(reqBody, url);
       

        if(responseData?.status == 200) {
            enqueueSnackbar(handleValidateCodevalue(internationalise,'COMMON_ADDED_SUCCESSFULLY ') , {variant: "success"});
        } else {
          enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_PLEASE_TRY_AGAIN"), {variant: 'error'})
        }
      }
    }
       const handleUpdateUser = (rowRecord) => {
        if(!isValidEmail(rowRecord?.userEmail)){
              enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_MSG_VALID_EMAIL"),{variant:'error'});
              return;
              }
          setIsLoading(true)
          const headerReq = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
            }
        }
    
        const Id = rowRecord?.id;
    
        const { ['id']: id, ['updated']: updated, ...UpdatedUserData} = rowRecord;
        
        const payload = {
            ...UpdatedUserData,
        }
        axios.put(`${process.env.REACT_APP_BASE_URL}users/${Id}`, payload, headerReq).then(response => {
            enqueueSnackbar(handleValidateCodevalue(internationalise,'COMMON_UPDATED_SUCCESSFULLY '), {variant: 'success'});
            
        }).catch(error => {
          if(error?.response?.status == 401) {
            sessionExpiredDialog();
          } else {
          enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_PLEASE_TRY_AGAIN"), {variant: 'error'})
          }
        }).finally(() => {
          setIsLoading(false);
        });}

    const handleSelectMultiRoles = (event, roles, reason) => {
        setSelectedRoles(roles)
    }
    const processRowUpdate = (newRow, oldRow) => {
            if(JSON.stringify(newRow) == JSON.stringify(oldRow)) {
              enqueueSnackbar(handleValidateCodevalue(internationalise,'COMMON_NO_DATA_CHANGED'), {variant: 'info'});
            } else {
              handleUpdateUser(newRow); 
            }
        const updatedRow = { ...newRow, isNew: false };
        setdatagriddata(datagriddata.map((row) => (row.id === newRow.id ? updatedRow : row)));
        return updatedRow;
      ;
    }
    

       const handleNotifyUserFromLeadPage = async(User, selectedLead) => {
          const url = `${process.env.REACT_APP_NODE_NOTIFICATION}/get-all-notification`;
          
                const responseData = await getRequestDataWithoutToken(url);
                const {data} = responseData;
                const filterData = data?.filter(item => item?.systemTemplateFlag !== "COMMON_YES") || [];
                const selectedDetails = User?.filter((item) =>selectedLead?.includes(item?.id))
                setIsOpenNotificationDialog({
                  ...isOpenNotificationDialog,
                  selectedDetails : selectedDetails,
                  isOpen : true,
                  templates : filterData
              });
          }
          
          const [isOpenNotificationDialog,setIsOpenNotificationDialog] = useState({
                isOpen : false,
                templates : [],
                selectedDetails : []
          })


    return (

        <BiztantuLoader isChildren={true} open={isLoadingProgress}>
           {(!iscreateuser && !isEdituser) ? <Box sx={{marginBottom: 0,
                // '& .MuiTextField-root': { m: 1, width: '29ch', marginTop: 3 },
                }}>
                  {isUserScreen &&
              <StyledConfigurationContainer>
                <Typography variant='h6'>
                  {handleValidateCodevalue(internationalise,'CONF_USER_SEARCH_TITLE')}
                </Typography>
              </StyledConfigurationContainer>
              }
              <StyledIndexContainerDiv>
                {isUserScreen &&
                <StyledLeadContainer sx={{backgroundColor: "#F4F9FE"}}>
                  <Stack className='table-header-search' spacing={2} width="40%" direction="row" backgroundColor="white">
                        <BiztantuSearch
                        entityDetails={formValues}
                        handleSearch={handleSearch}
                        handleReset={handleResetSearch}
                        >
                    <Box sx={{
                            '& .MuiTextField-root': { m: 1, width: '25ch', marginTop: 2 },
                            }}>                 
                <StyledLeadContainer>
                    <TextFiledWithLabel
                        type="number"
                        name="id"
                        value= {formValues?.id}
                        label={handleValidateCodevalue(internationalise,'CONF_USER_SEARCH_ID')}
                        handleOnChange={handleOnChange}
                    />
                     <AutoCompleteComponent
                        optionSet = {companyList}
                        value={formValues?.selectedCompany || null}
                        name = "clientId"
                        placeholder={handleValidateCodevalue(internationalise,'CONF_USER_SEARCH_CLIENT')}  
                        label={handleValidateCodevalue(internationalise,'CONF_USER_SEARCH_CLIENT')}           
                        onChange={handleSelectCompany}
                  />
                    <SelectBoxWithLabel
                        ownerdropdown = {false}
                        id="leadsource"
                        name="status"
                        isStatic = {false}
                        value={formValues?.status||""}
                        optionMenuItem={userStatusData}
                        label={handleValidateCodevalue(internationalise,'CONF_USER_SEARCH_STATUS')}
                        handleOnChange={handleOnChange}
                    />
                 
                <TextFiledWithLabel
                sx = {{visibility : "hidden"}}
                />
                  </StyledLeadContainer>       
                <StyledLeadContainer>
                    <TextFiledWithLabel
                        name="firstName"
                        value= {formValues?.firstName}
                        label={handleValidateCodevalue(internationalise,'CONF_USER_SEARCH_FIRSTNAME')}
                        handleOnChange={handleOnChange}
                    />
                    <TextFiledWithLabel
                        name="lastName"
                        value= {formValues?.lastName}
                        label={handleValidateCodevalue(internationalise,'CONF_USER_SEARCH_LASTNAME')}
                        handleOnChange={handleOnChange}
                    />
                    <NumericTextField
                        name = 'phone'
                        value={formValues?.phone}
                        handleOnChange={handleOnChange}
                        />
                        
                      <CommonEmail 
                      name = 'email'
                      value={formValues?.email}
                      handleOnChange={handleOnChange}
                      />
                </StyledLeadContainer>
                <WhoColumns
                searchState={formValues}
                handleOnChange = {handleOnChange}/>
                </Box> 
                        </BiztantuSearch>
                    </Stack>
                      <Stack className='secondry-btn-container' width="60%" padding="10px" justifyContent="flex-end" spacing={2} direction="row">
                        <>
                        <Button startIcon={<img src={createicon} style={{height: "15px"}} />} className='biztantu-sec-btn'  onClick={handleCreateuser}>{handleValidateCodevalue(internationalise,'CONF_USER_CREATE')}</Button>
                        </>
                    </Stack>
                </StyledLeadContainer>
            }
                <DataGridTable
                    dataGridData={datagriddata}
                    isLoading={isLoading}
                    height={"calc(100vh - 273px)"}
                    columns={columns}
                    rowModesModel={rowModesModel}
                    isRequiredToolBar = {true}
                    isUserScreen = {isUserScreen}
                    gridType='accountuser'
                    selectionModel={selectionModel}
                    setSelectionModel={(data) => setSelectionModel(data)}
                    handleProcessRowUpdate={processRowUpdate}
                    handleUpdateProduct={handleUpdateUser}
                    handleNotifyUser = {() => handleNotifyUserFromLeadPage(datagriddata, selectionModel)}
                    // handleUpdateProduct={handleUpdateProduct}
                />
              </StyledIndexContainerDiv>
            </Box> : 
                <CreateEditUser
                    setIsViewMode = {setIsViewMode}
                    isViewMode = {isViewMode}
                    handleResetSearch = {handleResetSearch}
                    isEdituser = {isEdituser} 
                    currentuserid={currentuserid}
                    handleCustomBackbutton = {handlebackbutton}
                    allrolesData = {allrolesData}
                    iscreateuser = {iscreateuser}
                    companyList = {companyList}
                    handleEditApplication={handleEditApplication}
                />

            }
            
      {
        (isOpenNotificationDialog?.isOpen) && (
          <SendNotification
            open={isOpenNotificationDialog?.isOpen}
            title= {handleValidateCodevalue(internationalise,"COMMON_NOTIFY_USER")}
            dataGridData={isOpenNotificationDialog?.templates}
            selectedDetails={isOpenNotificationDialog?.selectedDetails}
            setIsOpenNotificationDialog = {setIsOpenNotificationDialog}
            type = {"User"}
          />
        )
      }

              {
                (assignRoleDetails?.isOpen) && (
                    <LeadDialog 
                        open = {assignRoleDetails?.isOpen}
                        handleClose = {handleCloseAssignModal}
                        title= "Assign Roles"
                        size="sm"
                        selectedowner={true}
                        btnlabel="Save"
                        handleSave={handleSaveAssignRoles}
                    >
                      <Autocomplete
                        multiple
                        options={allrolesData}
                        sx={{width: true ? '50ch !important' : "65ch !important", padding: "7px", display: 'flex'}}
                        getOptionLabel={(option) => option?.name}
                        value={selectedRoles}
                        filterSelectedOptions = {true}
                        disableCloseOnSelect
                        limitTags={2}
                        onChange={handleSelectMultiRoles}
                        renderInput={(params) => (
                        <TextFiledWithLabel
                            {...params}
                            // error={selectedRoles?.length > 0 ? false : requiredValue?.permission}
                            required
                            label="Select Roles"
                            sx={{width: true ? '100% !important' : "65ch !important" , padding: "7px" }}
                            InputLabelProps={{
                            shrink: true,
                        }}
                        />
                        )}
                      />     
                    </LeadDialog>
                )
            }
        </BiztantuLoader>
    )
}

export default User;